/**
 * Три высокоуровневых режима пузыря по Telegram-модели.
 * - textBubble: любое сообщение с текстом (включая image+caption, attachment+text).
 * - imageOnlyBubble: только изображение, без текста.
 * - attachmentOnlyBubble: только вложение/чипы контекста, без текста и без фото.
 *
 * Мета:
 * - textBubble → всегда в правом нижнем углу: inline-float при отсутствии footer, в footer-строке при наличии.
 * - imageOnlyBubble → overlay-углу внутри блока изображения.
 * - attachmentOnlyBubble → overlay-углу внутри блока карточек.
 */
export type BubbleMode = 'textBubble' | 'imageOnlyBubble' | 'attachmentOnlyBubble';

export interface BubbleModeInput {
  hasText: boolean;
  hasImage: boolean;
  hasAttachment: boolean;
}

export function resolveBubbleMode({ hasText, hasImage }: BubbleModeInput): BubbleMode {
  if (hasText) return 'textBubble';
  if (hasImage) return 'imageOnlyBubble';
  return 'attachmentOnlyBubble';
}
